import { fabric } from 'fabric';

class ImageFilters {
  constructor(canvasManager) {
    this.canvasManager = canvasManager;
  }

  applyBrightness(obj, value = 0.1) {
    if (!this._isImage(obj)) return;
    this._removeFilterByType(obj, 'Brightness');
    obj.filters.push(new fabric.Image.filters.Brightness({ brightness: value }));
    obj.applyFilters();
    this.canvasManager.canvas.renderAll();
  }

  applyContrast(obj, value = 0.2) {
    if (!this._isImage(obj)) return;
    this._removeFilterByType(obj, 'Contrast');
    obj.filters.push(new fabric.Image.filters.Contrast({ contrast: value }));
    obj.applyFilters();
    this.canvasManager.canvas.renderAll();
  }

  applyGrayscale(obj) {
    if (!this._isImage(obj)) return;
    this._removeFilterByType(obj, 'Grayscale');
    obj.filters.push(new fabric.Image.filters.Grayscale());
    obj.applyFilters();
    this.canvasManager.canvas.renderAll();
  }

  applySepia(obj) {
    if (!this._isImage(obj)) return;
    this._removeFilterByType(obj, 'Sepia');
    obj.filters.push(new fabric.Image.filters.Sepia());
    obj.applyFilters();
    this.canvasManager.canvas.renderAll();
  }

  applyBlur(obj, value = 0.1) {
    if (!this._isImage(obj)) return;
    this._removeFilterByType(obj, 'Blur');
    obj.filters.push(new fabric.Image.filters.Blur({ blur: value }));
    obj.applyFilters();
    this.canvasManager.canvas.renderAll();
  }

  applyInvert(obj) {
    if (!this._isImage(obj)) return;
    this._removeFilterByType(obj, 'Invert');
    obj.filters.push(new fabric.Image.filters.Invert());
    obj.applyFilters();
    this.canvasManager.canvas.renderAll();
  }

  applyHueRotation(obj, rotation = 0) {
    if (!this._isImage(obj)) return;
    this._removeFilterByType(obj, 'HueRotation');
    obj.filters.push(new fabric.Image.filters.HueRotation({ rotation }));
    obj.applyFilters();
    this.canvasManager.canvas.renderAll();
  }

  applySaturation(obj, saturation = 0) {
    if (!this._isImage(obj)) return;
    this._removeFilterByType(obj, 'Saturation');
    obj.filters.push(new fabric.Image.filters.Saturation({ saturation }));
    obj.applyFilters();
    this.canvasManager.canvas.renderAll();
  }

  removeFilters(obj) {
    if (!this._isImage(obj)) return;
    obj.filters = [];
    obj.applyFilters();
    this.canvasManager.canvas.renderAll();
  }

  getActiveFilters(obj) {
    if (!this._isImage(obj)) return [];
    return obj.filters.map((f) => f.type);
  }

  _isImage(obj) {
    return obj && obj.type === 'image';
  }

  _removeFilterByType(obj, type) {
    obj.filters = obj.filters.filter((f) => f.type !== type);
  }
}

export default ImageFilters;
